import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveBounce20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoveBounce20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.422 2.425a4.5 4.5 0 1 1-.898 8.909l-2.36 4.364h5.984a.75.75 0 1 1 0 1.5H3.85a.75.75 0 0 1 0-1.5h2.84l-2.647-3.962a.75.75 0 0 1 1.247-.834l3.184 4.766 2.64-4.88a4.5 4.5 0 0 1 2.308-8.363m0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2.16 7.452a.75.75 0 0 1 1.04.207l.473.708a.75.75 0 0 1-1.247.834l-.473-.708a.75.75 0 0 1 .207-1.04"
            />
        </svg>
    );
}
export default memo(IconMoveBounce20);
